module.exports = __webpack_public_path__ + "images/marketing/peeps/adrian_ossowski.jpg";